import React, { lazy } from "react";
import { Navigate } from "react-router-dom";
import Loadable from "../layouts/full/shared/loadable/Loadable";
import { RouterName } from "./RouterName";
import { dataLocalStorage, getLocalStorage } from "src/helper/publicFunction";
import Fleet from "src/pages/fleet/view";

/* ***Layouts**** */
const FullLayout = Loadable(lazy(() => import("../layouts/full/FullLayout")));
const BlankLayout = Loadable(
  lazy(() => import("../layouts/blank/BlankLayout"))
);

/* ****Pages***** */
const Features = Loadable(lazy(() => import("src/pages/features/view")));
const Stats = Loadable(lazy(() => import("src/pages/stats/view")));
// const IntroCall = Loadable(lazy(() => import("src/pages/intro_call/view")));
const Testimonials = Loadable(
  lazy(() => import("src/pages/testimonials/view"))
);
const Settings = Loadable(lazy(() => import("src/pages/settings/view")));
const LegalInformation = Loadable(
  lazy(() => import("src/pages/settings/legal_information"))
);
const Logs = Loadable(lazy(() => import("src/pages/admins_logs/view")));
const Contact = Loadable(
  lazy(() => import("src/pages/settings/contact"))
);

// authentication
const Login = Loadable(
  lazy(() => import("../views/authentication/auth/Login"))
);

const ForgotPassword = Loadable(
  lazy(() => import("../views/authentication/auth/ForgotPassword"))
);
const ResetPassword = Loadable(
  lazy(() => import("src/views/authentication/auth/ResetPassword"))
);

const Error = Loadable(lazy(() => import("../views/authentication/Error")));
const Maintenance = Loadable(
  lazy(() => import("../views/authentication/Maintenance"))
);

const AdminsPage = Loadable(lazy(() => import("../pages/admins/admins/view")));
const PrivilegesPage = Loadable(
  lazy(() => import("../pages/admins/privileges/view"))
);

let data = getLocalStorage(dataLocalStorage.privileges);

const Router = [
  {
    path: "/",
    element: <FullLayout />,
    children: [
      {
        path: "/",
        exact: true,
        element: (
          <Navigate
            to={
              data["1"]?.access_read == 1
                ? RouterName.admins.admins
                : data["5"]?.access_read == 1
                  ? RouterName.settings.settings
                  : data["7"]?.access_read == 1
                    ? RouterName.features.features
                    : data["3"]?.access_read == 1
                      ? RouterName.fleet.fleet
                      : data["13"]?.access_read == 1
                        ? RouterName.testimonials.testimonials
                        : data["5"]?.access_read == 1
                          ? RouterName.contact.contact
                          : data["4"]?.access_read == 1
                            ? RouterName.stats.stats
                            : data["15"]?.access_read == 1
            }
          />
        ),
      },

      {
        path: RouterName.admins.admins,
        exact: true,
        element: <AdminsPage />,
      },
      data["1"]?.access_read == 1 && {
        path: RouterName.admins.privileges,
        exact: true,
        element: <PrivilegesPage />,
      },
      data["5"]?.access_read == 1 && {
        path: RouterName.settings.settings,
        exact: true,
        element: <Settings />,
      },
      data["5"]?.access_read == 1 && {
        path: RouterName.legal_information.legal_information,
        exact: true,
        element: <LegalInformation />,
      },
      data["7"]?.access_read == 1 && {
        path: RouterName.features.features,
        exact: true,
        element: <Features />,
      },
      data["13"]?.access_read == 1 && {
        path: RouterName.testimonials.testimonials,
        exact: true,
        element: <Testimonials />,
      },
      data["4"]?.access_read == 1 && {
        path: RouterName.stats.stats,
        exact: true,
        element: <Stats />,
      },
      data["3"]?.access_read == 1 && {
        path: RouterName.fleet.fleet,
        exact: true,
        element: <Fleet />,
      },

      {
        path: RouterName.contact.contact,
        exact: true,
        element: <Contact />,
      },
      {
        path: RouterName.admins_logs.admins_logs,
        exact: true,
        element: <Logs />,
      },

    ],
  },
  {
    path: "/",
    element: <BlankLayout />,
    children: [
      { path: "/auth/404", element: <Error /> },
      { path: RouterName.auth.login, element: <Login /> },
      { path: RouterName.auth.forgotPassword, element: <ForgotPassword /> },
      { path: RouterName.auth.resetPassword, element: <ResetPassword /> },
      { path: RouterName.auth.maintenance, element: <Maintenance /> },
      { path: "*", element: <Navigate to="/auth/404" /> },
    ],
  },
];

export default Router;
